import SettingDropdown from './SettingDropdown';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { defaultResolutionLabel, resolutionMap } from 'utils/videoResolution';
import { RootState } from 'store/reducers';
import DropdownLabel from 'components/Dropdown/DropdownLabel';

const messages = defineMessages({
  inputResolution: { id: 'components.avSettings.inputLabel.Resolution', defaultMessage: 'Resolution' },
  resolution360p: { id: 'components.avSettings.resolution360p', defaultMessage: 'Power Saving (360p)' },
  resolution4k: { id: 'components.avSettings.resolution4k', defaultMessage: 'Ultra-High Definition (4K)' },
  resolutionDefault: {
    id: 'components.avSettings.resolutionDefault',
    defaultMessage: 'Default Resolution ({resolution})'
  },
  resolutionFullHighDef: {
    id: 'components.avSettings.resolutionFullHighDef',
    defaultMessage: 'Full High Definition (1080p)'
  },
  resolutionHighDef: { id: 'components.avSettings.resolutionHighDef', defaultMessage: 'High Definition (720p)' }
});

const getResolutionLabels = (intl) => {
  return new Map([
    ['default', intl?.formatMessage(messages.resolutionDefault, { resolution: defaultResolutionLabel })],
    ['2160p', intl?.formatMessage(messages.resolution4k)],
    ['1080p', intl?.formatMessage(messages.resolutionFullHighDef)],
    ['720p', intl?.formatMessage(messages.resolutionHighDef)],
    ['360p', intl?.formatMessage(messages.resolution360p)]
  ]);
};

export interface Props {
  intl?: { formatMessage: Function };
  wide?: boolean;
  handleConfigChange: Function;
}

export const ResolutionDropdown = (props: Props) => {
  const { intl, handleConfigChange, wide } = props;
  const mediaSettings = useSelector((state: RootState) => state?.app?.mediaSettings);

  const resolutions = useMemo(() => {
    const resolutionLabels = getResolutionLabels(intl);
    return Object.values(resolutionMap).map((r) => ({ label: resolutionLabels.get(r.value) || '', value: r.value }));
  }, [intl]);

  return (
    <section>
      <DropdownLabel
        error={!(resolutions?.length > 0)}
        label={intl?.formatMessage(messages.inputResolution)}
        dataTestId={'qualitySelectionHeader'}
      />
      <SettingDropdown
        handleChange={(value) => handleConfigChange('resolution', value)}
        items={resolutions}
        label={intl?.formatMessage(messages.inputResolution)}
        testIdPrefix="quality"
        value={mediaSettings.resolution}
        wide={wide}
      />
    </section>
  );
};

export default injectIntl(ResolutionDropdown);
